import { apiClient } from './apiClient';

const base = '/api/providers';

export const providersService = {
  list: () => apiClient.get(base),
};

export default providersService;
